import { Link } from "react-router-dom";
import { SearchX, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PublicNav } from "@/components/public/PublicNav";
import { useSeoHeadTags } from "@/hooks/useSeoHeadTags";

// Presentational 404 body — reused by ServicePage/GalleryDetailPage for
// unknown slugs (those pages manage their own head tags).
export const NotFoundView = ({
  heading = "Page not found",
  message = "Sorry — we couldn't find the page you were looking for. It may have been moved or removed.",
}) => (
  <div className="pt-32 pb-24 px-4 text-center" data-testid="public-not-found">
    <SearchX className="h-12 w-12 mx-auto mb-6 text-muted-foreground opacity-40" aria-hidden="true" />
    <h1 className="text-3xl sm:text-4xl font-bold font-heading mb-4">{heading}</h1>
    <p className="text-muted-foreground max-w-md mx-auto mb-8">{message}</p>
    <div className="flex flex-wrap gap-3 justify-center">
      <Link to="/" data-testid="not-found-home-link">
        <Button className="rounded-full gap-2">
          <Home className="h-4 w-4" aria-hidden="true" />
          Back to Home
        </Button>
      </Link>
      <Link to="/gallery" data-testid="not-found-gallery-link">
        <Button variant="outline" className="rounded-full">View our work</Button>
      </Link>
    </div>
  </div>
);

export default function NotFoundPage() {
  useSeoHeadTags({
    title: "Page not found | Sustainable Handyman Services",
    description: "The page you were looking for could not be found on Sustainable Handyman Services.",
    canonical: null,
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-background">
      <PublicNav />
      <NotFoundView />
    </div>
  );
}
